import { render } from "./IconLoader.vue?vue&type=template&id=ff3c7ce4&scoped=true"
const script = {}

import "./IconLoader.vue?vue&type=style&index=0&id=ff3c7ce4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3c7ce4"]])

export default __exports__